import { fmtOdds } from "@/lib/odds";

const POS = { 1: "text-amber-300", 2: "text-slate-200", 3: "text-orange-300" };

export function RaceCard({ ev }) {
  if (!ev?.runners?.length) return null;
  const r = ev.race || {};
  const est = ev.odds_source === "estimate";
  const done = !!ev.result;
  return (
    <section className="glass-card p-5" data-testid="race-card">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-400">
        <span className="font-bold uppercase tracking-wider text-cyan-300">{r.name || "Race"}</span>
        {r.distance && <span>{r.distance}</span>}
        {r.surface && <span>{r.surface}</span>}
        {r.going && <span>{r.going}</span>}
        {r.age && <span>{r.age}</span>}
        <span className="ml-auto" data-testid="race-odds-source">{est ? "Odds: rank-based estimate (no live tote on current plan)" : "Odds: forecast / starting price"}</span>
      </div>
      <table className="mt-4 w-full text-sm">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-wider text-slate-500">
            <th className="pb-2 pr-2">PP</th><th className="pb-2 pr-2">Horse</th><th className="hidden pb-2 pr-2 sm:table-cell">Form</th><th className="hidden pb-2 pr-2 md:table-cell">Jockey / Trainer</th>
            <th className="pb-2 pr-2 text-right">Rtg</th><th className="hidden pb-2 pr-2 text-right sm:table-cell">Days</th><th className="pb-2 text-right">{done ? "Fin" : "Odds"}</th>
          </tr>
        </thead>
        <tbody>
          {ev.runners.map((h) => (
            <tr key={h.name} data-testid="race-runner" className={`border-t border-[#1B2436] ${h.position === 1 ? "bg-amber-500/5" : ""} ${h.casualty ? "opacity-40" : ""}`}>
              <td className="py-2 pr-2 font-mono-num text-slate-400">{h.post ?? "–"}</td>
              <td className="py-2 pr-2 font-semibold text-white">{h.name}{h.market_rank === 1 && <span className="ml-2 rounded bg-emerald-500/15 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider text-emerald-300">Fav</span>}{h.casualty && <span className="ml-2 text-[10px] uppercase text-red-300">{h.casualty}</span>}</td>
              <td className="hidden py-2 pr-2 font-mono-num text-slate-300 sm:table-cell">{h.form || "–"}</td>
              <td className="hidden py-2 pr-2 text-xs text-slate-400 md:table-cell">{h.jockey || "–"} <span className="text-slate-600">/</span> {h.trainer || "–"}</td>
              <td className="py-2 pr-2 text-right font-mono-num text-slate-300">{h.rating ?? "–"}</td>
              <td className="hidden py-2 pr-2 text-right font-mono-num text-slate-400 sm:table-cell">{h.last_run_days ?? "–"}</td>
              <td className={`py-2 text-right font-mono-num font-bold ${done ? POS[h.position] || "text-slate-500" : "text-amber-400"}`}>{done ? (h.position ?? "–") : <>{fmtOdds(h.odds)}{est && <span className="ml-1 text-[9px] font-semibold uppercase text-slate-500">est</span>}</>}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {done && ev.result.dividends && <p className="mt-3 text-xs text-slate-400" data-testid="race-dividends">Payouts: {Object.entries(ev.result.dividends).filter(([, v]) => v).map(([k, v]) => `${k.replace(/_/g, " ")} ${v}`).join(" · ")}</p>}
    </section>
  );
}
